var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "index"
  }, [_c('Header'), _c('div', {
    class: ['container', {
      'hide-global-nav': _vm.hiddenGlobalNav
    }],
    style: {
      marginTop: _vm.hiddenGlobalNav ? 0 : '80px'
    }
  }, [_vm.$route.name === 'ClassExamDetailV2' ? _c('router-view') : _c('div', {
    staticClass: "content"
  }, [_c('keep-alive', {
    attrs: {
      "include": _vm.$store.state.keepAliveInclude
    }
  }, [_c('router-view')], 1)], 1)], 1), _c('el-backtop', {
    attrs: {
      "target": "#app"
    }
  }, [_c('div', {
    staticClass: "backtop"
  }, [_c('div', {
    staticClass: "backtop-img"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/top.png"),
      "alt": "top"
    }
  })]), _c('div', {
    staticClass: "backtop-value"
  }, [_vm._v("回到顶部")])])])], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };